import { render } from "./WelcomeScreen.vue?vue&type=template&id=8b770e16"
import script from "./WelcomeScreen.vue?vue&type=script&lang=js"
export * from "./WelcomeScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/WelcomeScreen.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8b770e16"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8b770e16', __exports__)) {
    api.reload('8b770e16', __exports__)
  }
  
  module.hot.accept("./WelcomeScreen.vue?vue&type=template&id=8b770e16", () => {
    api.rerender('8b770e16', render)
  })

}


export default __exports__